import { createTheme } from '@mui/material/styles';
import { Components } from '@mui/material/styles/components';
import { ControllerTabsColor } from '../../palette';

const theme = createTheme();

export const TabsComponent: Components = {
  MuiTabs: {
    styleOverrides: {
      root: {
        minHeight: 0,

        '& button': {
          marginLeft: theme.spacing(1.5),
          marginRight: theme.spacing(1.5),
          minWidth: 0,
        },
        '& button:first-of-type': {
          marginLeft: theme.spacing(0.75),
        },
        '& button:last-of-type': {
          marginRight: theme.spacing(0.75),
        },
      },
      indicator: {
        backgroundColor: String(ControllerTabsColor.Indicator),
      },
    },
  },
};
